import React from "react";
import {
  IconApps,
  IconAppsBlue,
  IconBusinessMessages,
  IconBusinessMessagesBlue,
  IconCorporateFare,
  IconCorporateFareBlue,
  IconCrown,
  IconCrownBlue,
  IconInboxText,
  IconInboxTextBlue,
  IconSms,
  IconSmsBlue,
} from "assets/svg";

export const menuBuyer = [
  {
    to: "/buyer/dashboard",
    icon: <IconApps />,
    iconActive: <IconAppsBlue />,
    label: "ダッシュボード",
  },
  {
    to: "/buyer/information",
    icon: <IconCorporateFare />,
    iconActive: <IconCorporateFareBlue />,
    label: "登録情報の管理",
  },
  {
    to: "/buyer/transaction-status",
    icon: <IconBusinessMessages />,
    iconActive: <IconBusinessMessagesBlue />,
    label: "取引ステータスの管理",
  },
  {
    to: "/buyer/transaction-history",
    icon: <IconInboxText />,
    iconActive: <IconInboxTextBlue />,
    label: "取引履歴の閲覧",
  },
  {
    to: "/buyer/global-ranking",
    icon: <IconCrown />,
    iconActive: <IconCrownBlue />,
    label: "全体ランキング",
  },
  {
    to: "/buyer/conversation-inquiry",
    icon: <IconSms />,
    iconActive: <IconSmsBlue />,
    label: "お問い合わせ",
  },
];
